import type { ForgotPasswordDto, RegisterDto } from '@/modules/authentication/contracts/dto/auth.dto';

import type { ForgotPasswordFormModel } from '../models/forgot-password.form-model';
import type { RegistrationFormModel } from '../models/registration.form-model';
import type { ResetPasswordFormModel } from '../models/reset-password.form-model';

export const mapForgotPasswordFormToDto = (form: ForgotPasswordFormModel): ForgotPasswordDto => {
	return { body: { email: form.email } };
};

export const mapResetPasswordFormToDto = (form: ResetPasswordFormModel) => {
	return {
		oob:      form.oobCode,
		password: form.password,
	};
};

export const mapRegistrationFormToDto = (form: RegistrationFormModel): RegisterDto => {
	return {
		body: {
			email:     form.email,
			firstName: form.firstName,
			lastName:  form.lastName,
			password:  form.password,
		},
	};
};
